module.exports = __webpack_public_path__ + "static/media/arrowDown.e77989e7.svg";